import * as Yup from 'yup';

export const createNewAccountValidationSchema = Yup.object({
  firstName: Yup.string().required('Required field'),
  lastName: Yup.string().required('Required field'),
  email: Yup.string().email('Invalid E-mail').required('Required field'),
  password: Yup.string()
    .required('Required field')
    .min(8, 'Password must be at least 8 characters long'),
  repeatPassword: Yup.string()
    .required('Required field')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});
